<template>
  <div>
    <selectors
      :selectKey="titleKey"
      :modal="modal"
      v-model="val"
      :title="title"
      @input="input"
    />
  </div>
</template>
<script>
export default {
  props: {
    modal: {
      default: "",
    },
    title: {
      default: "",
    },
    titleKey:{
      default:"title"
    }
  },
  name: "filter",
  components: {
    selectors: () => import("./Inputs/Selectors"),
  },
  methods: {
    input() {
      let value = [];
      for(let i =0;i<this.val.length;i++){
        value.push(this.val[i].id);
      }

      this.$emit("input", value.join('-'));
    },
  },
  data() {
    return {
      val: [],
    };
  },
};
</script>
<style>
</style>
